import { Controller } from "@hotwired/stimulus"

const THRESHOLD = 8

export default class extends Controller {
  static classes = ["hidden"]

  connect() {
    this.lastY = window.scrollY
    this.onScroll = this.onScroll.bind(this)

    window.addEventListener("scroll", this.onScroll, { passive: true })
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  onScroll() {
    const y = window.scrollY
    const delta = y - this.lastY

    if (Math.abs(delta) < THRESHOLD) return

    const hide = delta > 0 && y > this.element.offsetHeight

    this.element.classList.toggle(this.hiddenClass, hide)
    this.lastY = y
  }
}
